module.exports = __webpack_public_path__ + "img/xzc.2eeb3249.svg";